import { useMemo } from 'react'
import { type Contact } from 'entities/Contacts/model/Contact'
import { RowContact } from 'entities/Contacts/model/Table/RowContact'

export const useContactsTableRows = (contacts: Contact[]): RowContact[] => {
  return useMemo(() => {
    const contactsRows = contacts.map((item) => new RowContact(item))

    return contactsRows.map((row) => {
      row.setDisabled(row.isArchived)

      return row
    })
  }, [contacts])
}
